import React, { useEffect, useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import * as jwtDecode from 'jwt-decode'; // Import a library for decoding JWT tokens
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import './custom.css';
import config from './config.json';

const App = () => {
  return (
    <Layout>
      <Routes>
        {AppRoutes.map((route, index) => {
          const { element, ...rest } = route;
          return <Route key={index} {...rest} element={element} />;
        })}
      </Routes>
    </Layout>
  );
};

export default App;
